import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=37b5a61a"
import script from "./Qualifications.vue?vue&type=script&lang=js"
export * from "./Qualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports